var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 95,
    viewBox: "0 0 463 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.275 86.025L424.25 87.75L428.275 89.475L430 93.5L431.725 89.475L435.75 87.75L431.725 86.025L430 82L428.275 86.025Z",
    stroke: "#D89F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.025 81.75L24 83.475L28.025 85.2L29.75 89.225L31.475 85.2L35.5 83.475L31.475 81.75L29.75 77.725L28.025 81.75Z",
    stroke: "#D89F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.034 6.09397L383.009 7.81897L387.034 9.54397L388.759 13.569L390.484 9.54397L394.509 7.81897L390.484 6.09397L388.759 2.06897L387.034 6.09397Z",
    stroke: "#D89F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.775 41.525L1.75 43.25L5.775 44.975L7.5 49L9.225 44.975L13.25 43.25L9.225 41.525L7.5 37.5L5.775 41.525Z",
    stroke: "#D89F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.025 34.525L450 36.25L454.025 37.975L455.75 42L457.475 37.975L461.5 36.25L457.475 34.525L455.75 30.5L454.025 34.525Z",
    stroke: "#D89F5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.275 7.47501L84.25 9.20001L88.275 10.925L90 14.95L91.725 10.925L95.75 9.20001L91.725 7.47501L90 3.45001L88.275 7.47501Z",
    stroke: "#D89F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.0330cb77cee07011b32e8378434c36d4.svg";
export { ForwardRef as ReactComponent };